module.exports = __webpack_public_path__ + "img/ms.57cb3b44.svg";